import React from 'react';
import {
  Box,
} from '@mui/material';

const DriverDetailsActionBar = ({
  driver,
  driverStatus,
}) => {

  return (
    <Box sx={{ mb: 2, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      {/* No action buttons available - endpoints not in swagger */}
    </Box>
  );
};

export default DriverDetailsActionBar; 